import React, { useEffect, useState } from 'react'
import logoSvg from '../../assets/images/sensei-new-logo.svg'
import logoSvg2 from '../../assets/images/sensei-new-logo-2.0.svg'
import AfterLogedIn from '../Login/AfterLogedIn'
import NonLogedin from '../Login/NonLogedin'
import { useSelector ,useDispatch } from 'react-redux'
import { ShowMeasure, UsertourAction } from '../../action'
import { onResize } from '../../redux/reducers/building_component/componentReducer'
import { manufacturerLogo } from '../../redux/reducers/utils'
import CallForPricing from './CallForPricing'
import SaveButtonFunction from '../ControlPanel/Common/SaveButton'
import { addLeadDetails, handleSaveLatter, handleSavePublicQuote } from '../../action/quote_order/quote.action'
import { handleCommonModal, handleProductModal } from '../../action/quote_order/leadcustomer.action'
import { CheckCaptureModalImage } from '../../action/extra_options/orderExtras.action'
import { downloadOnClick, prepareTwoDMapData } from '../../action/2d_mapping/twoDMap.action'
import { const_var } from '../../redux/reducers/reducer'

function SlideHeader() {
    const dispatch = useDispatch();
    const props = useSelector((state) => state.reducer);
    const [isActiveLogin, setIsActiveLogin] = useState(false);
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        manufacturerLogo().then((url) => {
        if (url) setLogoUrl(url);
        });
    }, []);

    useEffect(() => {
        if (localStorage.getItem('userData')!=undefined) {
            setIsActiveLogin(true)
        }
        else {
            setIsActiveLogin(false)
        }
    }, [])


    const onSaveClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        //autoGeneratedPDF();
        if (props.const_var.callMesure) {
          dispatch(ShowMeasure("save"));
        }
      };
    
    const saveShareClick = () => {
        const {loginSession, crmSetting, isPublicEdit, i_g_A_y } = props.const_var;
        if(crmSetting.is_module_name == 'inventory'){
            dispatch(handleProductModal());
        }else{
            if(isPublicEdit != true){
                if(crmSetting.form_action == "edit" && i_g_A_y.length > 0){
                    dispatch(CheckCaptureModalImage('open'));
                }else{
                    if(loginSession == false){
                        dispatch(handleSaveLatter('open'));
                    }else{
                        dispatch(handleCommonModal('lead_customer', 'save'));
                    }
                }
            }else{
                dispatch(handleSavePublicQuote('open'));
            }
            onSaveClick();
        }
      }

    const clickbuildingfullview = () => {
        // const checkfullbuilding = document.querySelector('.activethumb-view');
  
        // if(checkfullbuilding!==null) {
        //     // document.querySelector('.togglebuildingview').click();
        //     // setTimeout(()=>{        
        //     //     cuComponent.onResize();
        //     // },500)
        //     dispatch(UsertourAction(true, '',0)) 
        // }
        // cuComponent.onResize();
        dispatch(UsertourAction(true, '',0))  
    }
    let dynamicLogo = logoUrl;
    let logoIMG = window.location.origin + '/logo.svg';
   if(props.const_var.loginSession == true && dynamicLogo /* props.const_var.crmSetting.api_token=="7KJeHld8lthhZRr0qzJEjYfnbjmXhXiKSGa73bv1XqENGNIthoKdbT4gIznBTV7i" */)
   {
        logoIMG = dynamicLogo;
   }else{
        logoIMG = window.location.origin + '/logo.svg';
   }
//    if(props.const_var.crmSetting.is_CRM_V4==true)
//    {
//         logoIMG = 'https://r3fstaging.sensei3d.com/logo.svg';
//    }
    if(window.location.href.includes('3d-shareable-link')==true)
    {
        logoIMG = props.const_var.crmSetting.source+'logo.svg';
    } 
    const checkHiddenClass = document.body.classList.contains('hidden-customer-edit')
    
    return (
        <div className={props.selectedTabstate == 'statechange' ? 'top-bar-state-page' : 'top-bar' } >
            <div className={'top-left-bar'+ (props.const_var.crmSetting.main_domain_url == "americansteelinc.com" ? ' top-left-bar-inc' : '')}>
                
                {
                    props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'
                    ?
                        <div className='metal-depotllc-btns'>
                            <button
                                // onClick={() => {dispatch(addLeadDetails('open'));}}
                                onClick={() => saveShareClick()}
                                className={props.const_var.is_loader == false ? "btn btn-primary mr-2" : "btn btn-primary disabled mr-2"}
                            >
                                <span className="icon mr-1"><i className="icon-quote-icon"></i></span>
                                <span className="text"> GET FORMAL QUOTE</span>
                            </button>
                            {
                                props.const_var.crmSetting.order_now == true &&
                                props.const_var.checkmoreCustomizeFlag == false &&
                                props.const_var.stateData &&
                                props.const_var.stateData.hide_price_calculation == 0 &&
                                (
                                props.const_var.crmSetting.is_show_cta == true ||
                                props.const_var.crmSetting.is_show_cta == undefined
                                ) &&
                                props.const_var.loginSession === false &&
                                props.const_var.crmSetting.is_module_name !== "inventory" &&
                                !(
                                props.const_var.isPublicEdit === true &&
                                props.const_var.crmSetting.is_quote_Edit === true
                                ) &&
                                props.const_var.isPublicEdit !== true
                                ? (
                                    props.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'
                                    ?
                                        <span className="icon icon-save" 
                                        onClick={() => saveShareClick()}
                                        ></span>
                                    :
                                    <div className='nav-box-white a save-icon-header-wrp'>
                                    { 
                                        props.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || props.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com"
                                        ?
                                        <SaveButtonFunction headerShow={true} class_name={props.const_var.is_loader == false? "btn btn-block btn-primary btn-show-order-enable btn-share" : "btn btn-block btn-primary btn-show-order-enable btn-share disabled"}/>
                                        :
                                        <span className="icon icon-save" 
                                        onClick={() => saveShareClick()}
                                        ></span>
                                    }
                                    </div>
                                )
                                : ((checkHiddenClass && props.const_var.isPublicEdit === true) || !props.const_var.isPublicEdit) && ( <div className="nav-box-white">
                                    <SaveButtonFunction headerShow={true} class_name={props.const_var.is_loader == false? "btn btn-block btn-primary btn-share" : "btn btn-block btn-primary btn-share disabled"}/>
                                    </div>)
                            }
                        </div>
                    :
                    ((props.const_var.crmSetting.main_domain_url == '' && !dynamicLogo) || (props.const_var.crmSetting.main_domain_url == 'vaibhavcibirix.com')) ?
                    <div className='top-logo w110'><img src={window.location.origin + '/logo.svg' } alt='logo img'/></div>
                    // <div className='top-logo w110'><img src={logoSvg2} alt='logo img'/></div>
                    :
                    <div className='top-logo'><img src={logoIMG} alt='logo img'/></div>
                }
            </div>
            
           
            {
                !const_var?.is_intel &&
                <>
            
            <div className='top-right-bar'>           
                { props.const_var.loginSession || isActiveLogin ?<AfterLogedIn />:<NonLogedin/>}
                {
                    !props.const_var.loginSession &&
                    <div className='call-price-wrp'>
                        <CallForPricing />        
                    </div>  
                }
                {
                    props.selectedTabstate != "statechange" && <span className="icon-tour-1 tour-icon-style" onClick={()=> clickbuildingfullview()}></span>
                }
            </div>
            </>
}
        </div>
    )
}

export default SlideHeader